export * as coordsmodal from './owner.coordsmodal'
export * as details from './owner.details'
export * as detailsflag from './owner.detailsflag'
export * as detailsmap from './owner.detailsmap'
export * as detailslight from './owner.detailslight'
export * as detailsproperties from './owner.detailsproperties'
export * as listownersforproperty from './owner.listownersforproperty'
export * as ownersonsameaddress from './owner.ownersonsameaddress'
export * as notes from './owner.notes'
